var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from "react";
import ActionMenu from "../menu/ActionMenu";
import { withPortal } from "../../hoc/withPortal";
import Tooltip from "../tooltip/Tooltip";
import ActionBarButton from "./ActionBarButton";
import useUniqueId from "../../hooks/useUniqueId";
const prefixId = "nx-actionbar-menu-";
const withActionMenuPortal = withPortal((_a) => {
    var { onSelect, hide, tooltipPosition, maxHeight, isVisible, show, update } = _a, restActionMenuProps = __rest(_a, ["onSelect", "hide", "tooltipPosition", "maxHeight", "isVisible", "show", "update"]);
    return (React.createElement(Tooltip, { position: tooltipPosition, variant: "action" },
        React.createElement(ActionMenu, Object.assign({ onSelect: (id, event) => {
                if (onSelect) {
                    onSelect(id, event);
                }
                hide(0);
            }, onHide: () => {
                hide(0, true);
            }, maxHeight: maxHeight ? maxHeight : "50vh", tooltipPosition: tooltipPosition }, restActionMenuProps))));
}, {
    alignment: "top",
    trigger: "click",
    position: "fixed",
    hide: false,
    offset: [0, 8],
    container: document.body,
    shouldHideWhenTargetHidden: false,
    useFocusTrap: false,
    allowTabNavigation: false,
});
const WithPortalActionBarButton = (label, disabled, iconName, ariaRole) => {
    const PortalActionBarButton = (props) => {
        const { onClick, forwardedRef, isVisible, id } = props;
        return (React.createElement(ActionBarButton, Object.assign({ ref: forwardedRef, onClick: onClick, disabled: disabled, "aria-controls": id, "aria-expanded": isVisible, iconName: iconName }, (ariaRole && { role: ariaRole })), label));
    };
    PortalActionBarButton.displayName = "PortalActionBarButton";
    return PortalActionBarButton;
};
const ActionBarActionMenu = (_a) => {
    var { id, label, disabled, iconName, ariaRole } = _a, rest = __rest(_a, ["id", "label", "disabled", "iconName", "ariaRole"]);
    id = useUniqueId(prefixId, id);
    const Button = useMemo(() => WithPortalActionBarButton(label, disabled, iconName, ariaRole), [label, disabled, iconName]);
    const ButtonWithActionMenuPortal = useMemo(() => withActionMenuPortal(Button), [Button]);
    return React.createElement(ButtonWithActionMenuPortal, Object.assign({ id: id, "aria-label": label }, rest));
};
export default ActionBarActionMenu;
//# sourceMappingURL=ActionBarActionMenu.js.map